import React, { useState, useEffect } from 'react';
import { Modal, Pagination, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useAssetPaginationQuery } from '../generated/graphql';
import ShoppingCart from '@ozoneuniverse/ui-components/build-pkg/src/components/shopping-cart/ShoppingCart';
import { useGetCartQuery } from '../generated/graphql';
import { useCreateCartMutation } from '../generated/graphql';
import { ProductsGrid } from '@ozoneuniverse/ui-components/build-pkg/src/components/asset-store/products/ProductsGrid';
import { debounce } from 'lodash';
import styles from './asset-store.module.css';

const PAGE_LIMIT = 16;

export default function AssetStore({ isOpen, closeStore, userEmail }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [nameToSearch, setNameToSearch] = useState('');
  const [createCart] = useCreateCartMutation({
    variables: {
      data: {
        userEmail: userEmail ?? '',
      },
    },
  });

  const { data } = useGetCartQuery({
    variables: {
      data: {
        userEmail: userEmail ?? '',
      },
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!data?.getCart.status) {
      const create = async () => {
        await createCart();
      };
      create();
    }
  }, []);

  const {
    data: assets,
    error,
    loading,
  } = useAssetPaginationQuery({
    variables: {
      where: {
        offset: PAGE_LIMIT * (currentPage - 1),
        limit: PAGE_LIMIT,
        filter: {
          name: nameToSearch,
        },
      },
    },
    fetchPolicy: 'network-only',
  });

  const getResults = debounce(async (name) => {
    setNameToSearch(name);
  }, 800);

  const onSearch = async (input) => {
    if (input.target.value.length <= 1) {
      getResults.cancel();
      return setNameToSearch('');
    }

    return getResults(input.target.value);
  };

  return (
    <Modal
      title={
        <div className={styles.titleModal}>
          <div className={styles.shopCartWrapper}>
            <ShoppingCart
              data={
                data?.getCart.cart
                  ? data?.getCart.cart?.map((i) => ({
                      ...i,
                      price: parseFloat(i.price),
                    }))
                  : []
              }
              userEmail={userEmail}
            ></ShoppingCart>
          </div>
          <span className={styles.titleModalText}>NFT assets store</span>
        </div>
      }
      className={styles.modal}
      bodyStyle={{ minHeight: 600 }}
      open={isOpen}
      footer={false}
      width={920}
      onCancel={closeStore}
      zIndex={1001}
    >
      <div className={styles.searchWrapper}>
        <Input
          placeholder='Search assets'
          className={styles.search}
          onChange={onSearch}
          prefix={<SearchOutlined className={styles.iconSearch} />}
        />
      </div>
      <ProductsGrid
        data={assets?.assetPagination?.assets as any}
        error={error as any}
        loading={loading}
        disableLink={true}
      />
      <div className={styles.paginationWrapper}>
        <Pagination
          defaultCurrent={1}
          pageSize={PAGE_LIMIT}
          total={assets?.assetPagination.totalCount}
          hideOnSinglePage
          showSizeChanger={false}
          onChange={(page) => {
            setCurrentPage(page);
          }}
          className={styles.pagination}
        />
      </div>
    </Modal>
  );
}
